import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"
import { Experience as Roles } from "../../data/ResumeData"
import { Section, Inner, Label, Heading, reveal, revealDelay } from "./ui"

const Timeline = styled.div`
position: relative;
margin-top: 1rem;
padding-left: clamp(1.2rem, 3vw, 2rem);
border-left: 1px solid ${t.border};
`

const Item = styled(motion.article)`
position: relative;
padding: 0 0 2.6rem clamp(1.2rem, 3vw, 2.2rem);

&:last-child{ padding-bottom: 0; }

&::before{
    content: "";
    position: absolute;
    left: calc(-1px - clamp(1.2rem, 3vw, 2rem) - 5px);
    top: 0.35rem;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: ${t.bg};
    border: 2px solid ${t.accent};
    box-shadow: 0 0 0 4px rgba(${t.accentRgba}, 0.12);
}
`

const Period = styled.span`
font-family: ${t.mono};
font-size: 0.78rem;
color: ${t.accent};
letter-spacing: 0.02em;
`

const Role = styled.h3`
font-size: clamp(1.1rem, 2.2vw, 1.4rem);
margin: 0.5rem 0 0.15rem;
`

const Company = styled.p`
font-family: ${t.mono};
font-size: 0.9rem;
color: ${t.muted};
margin-bottom: 0.7rem;
`

const Summary = styled.p`
color: ${t.muted};
max-width: 64ch;
line-height: 1.7;
margin-bottom: 0.9rem;
`

const Stack = styled.div`
display: flex;
flex-wrap: wrap;
gap: 0.5rem;
`

const Chip = styled.span`
font-family: ${t.mono};
font-size: 0.72rem;
color: ${t.faint};
border: 1px solid ${t.border};
border-radius: 999px;
padding: 0.25rem 0.7rem;
`

const Experience = () => {
    return (
        <Section id="experience">
            <Inner>
                <Label num="02" {...reveal}>Experience</Label>
                <Heading {...reveal}>Where I've worked.</Heading>
                <Timeline>
                    {Roles.map((r, i) => (
                        <Item key={r.role + r.period} {...revealDelay(i)}>
                            <Period>{r.period}</Period>
                            <Role>{r.role}</Role>
                            <Company>{r.company}</Company>
                            <Summary>{r.summary}</Summary>
                            <Stack>
                                {r.stack.map((s) => (
                                    <Chip key={s}>{s}</Chip>
                                ))}
                            </Stack>
                        </Item>
                    ))}
                </Timeline>
            </Inner>
        </Section>
    )
}

export default Experience
